/**
 * "Conversation & usage logs" — Dashboard section (ADR-0074).
 * Reconciled from apps/web conversation-logs (route /conversation-logs — a
 * tabbed surface: Conversations feed / Insights subpage / Needs attention — and
 * the merged one-page conversation drill-in at /conversation-logs/:id, per
 * ADR-0319) and usage-logs (Monitoring → Activity, § 2.4 of the business-visibility program) features.
 */
import type { DocPageContent } from '../types';

export const DASHBOARD_CONVERSATION_LOGS_PAGE: DocPageContent = {
  slug: 'dashboard/conversation-logs',
  titleKey: 'docs.dashboard.convlogs.title',
  descriptionKey: 'docs.dashboard.convlogs.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.dashboard.convlogs.lead' },

    {
      kind: 'heading',
      level: 2,
      id: 'insights',
      textKey: 'docs.dashboard.convlogs.insights.heading',
    },
    { kind: 'paragraph', textKey: 'docs.dashboard.convlogs.insights.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.dashboard.convlogs.insights.item.funnel',
        'docs.dashboard.convlogs.insights.item.outcomes',
        'docs.dashboard.convlogs.insights.item.gaps',
        'docs.dashboard.convlogs.insights.item.briefing',
      ],
    },

    { kind: 'heading', level: 2, id: 'list', textKey: 'docs.dashboard.convlogs.list.heading' },
    { kind: 'paragraph', textKey: 'docs.dashboard.convlogs.list.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.dashboard.convlogs.list.item.outcome',
        'docs.dashboard.convlogs.list.item.filter',
        'docs.dashboard.convlogs.list.item.export',
      ],
    },

    {
      kind: 'heading',
      level: 2,
      id: 'transcript',
      textKey: 'docs.dashboard.convlogs.transcript.heading',
    },
    { kind: 'paragraph', textKey: 'docs.dashboard.convlogs.transcript.body' },

    { kind: 'heading', level: 2, id: 'usage', textKey: 'docs.dashboard.convlogs.usage.heading' },
    { kind: 'paragraph', textKey: 'docs.dashboard.convlogs.usage.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.dashboard.convlogs.usage.item.events',
        'docs.dashboard.convlogs.usage.item.cost',
        'docs.dashboard.convlogs.usage.item.export',
      ],
    },

    {
      kind: 'callout',
      tone: 'important',
      titleKey: 'docs.dashboard.convlogs.privacy.title',
      textKey: 'docs.dashboard.convlogs.privacy.body',
      links: {
        privacy: {
          target: { docSlug: 'trust/privacy' },
          labelKey: 'docs.dashboard.convlogs.privacy.link.privacy',
        },
        data: {
          target: { docSlug: 'trust/data' },
          labelKey: 'docs.dashboard.convlogs.privacy.link.data',
        },
      },
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.dashboard.convlogs.next.audit.title',
          textKey: 'docs.dashboard.convlogs.next.audit.text',
          to: { docSlug: 'dashboard/audit' },
        },
        {
          titleKey: 'docs.dashboard.convlogs.next.monitoring.title',
          textKey: 'docs.dashboard.convlogs.next.monitoring.text',
          to: { docSlug: 'dashboard/monitoring' },
        },
      ],
    },
  ],
};
